import Css from "./style.module.scss";

import React from "react";
import classNames from "classnames";

const SideBarFooter = ({ children, className, ...restProps }) => {
  return (
    <div className={classNames(Css.sideBarFooter, className)} {...restProps}>
      {children}
    </div>
  );
};

export default React.memo(SideBarFooter);
